module.exports = __webpack_public_path__ + "media/assets/images/flags/pt-b02b5546fa4b08e5e74c93cf212a36c3.svg";